import keysToConstants from 'js/lib/keysToConstants';

import type { ItemFlagLabelKey } from 'bundles/authoring/course-content-feedback/components/ItemFlagStatus';
import type {
  FeedbackCategoryState,
  FeedbackComments,
  FeedbackContext,
  FeedbackDebugInfo,
  FlagCategory,
} from 'bundles/authoring/course-content-feedback/types/courseContentFeedback';

import Feedback from './Feedback';

export type FlagFeedbackProps = {
  active: boolean;
  comments: FeedbackComments;
  timestamp: number;
  context: FeedbackContext;
  debugInfo: FeedbackDebugInfo;
  categoryStates: FeedbackCategoryState;
  id: string;
};

class FlagFeedback extends Feedback {
  static statuses = keysToConstants(['UNRESOLVED', 'TODO', 'RESOLVED', 'ARCHIVED']);

  constructor(props: FlagFeedbackProps) {
    const { active, comments, timestamp, context, debugInfo, categoryStates, id } = props;

    const maxValue = 0;
    const value = 0;

    const feedback = {
      rating: { value, maxValue, active },
      comments: comments || {},
      timestamp,
      context,
      debugInfo,
      categoryStates,
      id,
    };

    super(feedback);
  }

  getComment(flagCategory: FlagCategory) {
    if (flagCategory.isHelpfulOrConfused()) {
      return this.comments.generic;
    }
    return this.comments[flagCategory.id];
  }

  getStatus(flagCategory: FlagCategory) {
    if (flagCategory.isHelpfulOrConfused()) {
      return this.categoryStates?.generic && this.categoryStates?.generic.status;
    }
    return this.categoryStates?.[flagCategory.id] && this.categoryStates[flagCategory.id].status;
  }

  setStatus(flagCategory: FlagCategory, status: ItemFlagLabelKey) {
    if (flagCategory.isHelpfulOrConfused()) {
      this.categoryStates = {
        ...this.categoryStates,
        generic: { status },
      };
    }
    this.categoryStates = {
      ...this.categoryStates,
      [flagCategory.id]: { status },
    };
  }
}

export default FlagFeedback;

export const { statuses } = FlagFeedback;
